import { render, staticRenderFns } from "./RegionManagement.vue?vue&type=template&id=2178c7e2&"
import script from "./RegionManagement.vue?vue&type=script&lang=js&"
export * from "./RegionManagement.vue?vue&type=script&lang=js&"
import style0 from "./RegionManagement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports